








import { Component, Vue, Prop } from 'vue-property-decorator'
import { ChatLog } from '@/class/chat'

@Component
export default class ChatLogViewer extends Vue {
  @Prop() logs!: ChatLog[];

  created () {
    this.$watch('logs', async () => {
      const element = document.querySelector('#chat_log')
      if (element) {
        if (element.scrollTop + element.clientHeight === element.scrollHeight) {
          await this.$nextTick()
          element.scrollTop = element.scrollHeight
        }
      }
    })
  }
}
